import { Flex } from '@chakra-ui/react';
import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { z } from 'zod';

import { PortfolioTransactionsContent } from './PortfolioTransactionsContent';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { PermissionGuard, PermissionsFn } from '~/core/PermissionGuard';

const RouteParamsStruct = z.object({
  creditFacility: z.string({ message: 'Missing URL parameter' }),
});

export const permissions: PermissionsFn = (context) => {
  if (context.user.organization.slug === 'valleyBank') return 'deny';
  return context.flags.productsTransactionsPermissions;
};

const RouteBase = () => {
  const [queryParams] = useSearchParams();
  const { creditFacility: creditFacilityId } = RouteParamsStruct.parse(
    Object.fromEntries(queryParams),
  );

  return (
    <PortfolioTransactionsContent
      key={creditFacilityId}
      creditFacilityId={creditFacilityId}
    />
  );
};

export const Route = () => {
  return (
    <PermissionGuard permissions={permissions}>
      <RouteErrorBoundary
        fallback={({ message, showErrorToast }) => {
          showErrorToast(message);
          return <Navigate to="/portfolio/overview/facilities" replace />;
        }}
      >
        <Flex
          direction="column"
          padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}
        >
          <RouteBase />
        </Flex>
      </RouteErrorBoundary>
    </PermissionGuard>
  );
};
